module.exports = __webpack_public_path__ + "img/mp4.b4aef9d3.svg";